import React, { useEffect } from "react";
import styled from "styled-components";
import { useNewsStore } from "../../stores/newsStore";
import { NewsCard } from "./NewsCard";

const Section = styled.section`
  padding: 80px 0;
`;

const Container = styled.div`
  max-width: 600px;
  margin: 0 auto;
  padding: 0 20px;

  @media (min-width: 768px) {
    max-width: 1200px;
    padding: 0 40px;
  }

  @media (min-width: 1024px) {
    max-width: 1400px;
    padding: 0 60px;
  }
`;

const NewsGrid = styled.div`
  display: flex;
  flex-direction: column;
  gap: 40px;

  @media (min-width: 768px) {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 60px;
  }

  @media (min-width: 1024px) {
    gap: 80px;
  }
`;

const LoadMoreButton = styled.button`
  display: block;
  margin: 60px auto 0;
  padding: 12px 32px;
  background: #000;
  color: #fff;
  border: none;
  border-radius: 4px;
  font-size: 1rem;
  font-weight: 500;
  cursor: pointer;
  transition: background 0.2s ease;

  &:hover:not(:disabled) {
    background: #333;
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

const LoadingMessage = styled.p`
  text-align: center;
  color: #666;
  opacity: 0.6;
  margin-top: 40px;
`;

export const NewsSection: React.FC = () => {
  const { news, loading, hasMore, fetchNews } = useNewsStore();

  useEffect(() => {
    fetchNews(true);
  }, [fetchNews]);

  const handleLoadMore = () => {
    fetchNews(false);
  };

  return (
    <Section>
      <Container>
        <NewsGrid>
          {news.map((item) => (
            <NewsCard key={item.id} news={item} />
          ))}
        </NewsGrid>
        {loading && <LoadingMessage>Caricamento...</LoadingMessage>}
        {hasMore && !loading && (
          <LoadMoreButton onClick={handleLoadMore} disabled={loading}>
            Carica altre novità
          </LoadMoreButton>
        )}
      </Container>
    </Section>
  );
};
